import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LoginComponent } from './login.component';
import { FormsModule } from '@angular/forms';
import { CommonServiceLayerService } from '../services/common-service-layer.service';
import { SharedModule } from '../shared/shared.module';
import { MapLoaderModule } from '../shared/map-loader/map-loader.module';
import { UserLoginComponent } from './user-login/user-login.component';
import { PageNotFoundComponent } from './page-not-found/page-not-found.component';

@NgModule({
  declarations: [LoginComponent, UserLoginComponent, PageNotFoundComponent],
  imports: [
    CommonModule,
    FormsModule,
    SharedModule,
    MapLoaderModule
  ],
  exports: [LoginComponent],
  providers: [CommonServiceLayerService]
})
export class LoginModule { }
